export const setCampgrounds = (state, payload) => {
  state.campgrounds = payload
}
export const setCampsites = (state, payload) => {
  state.campsites = payload
}
export const setCampsiteTypes = (state, payload) => {
  state.campsiteTypes = payload
}
export const setCampsiteWeek = (state, payload) => {
  // add week to campsites
  state.campsites = state.campsites.map((campsite) => {
    // append the associated blackouts and bookings to the site
    let blackouts = payload.blackouts?.[campsite.campsiteID] || {}
    let bookings = payload.bookings?.[campsite.campsiteID] || {}
    let strictBlackouts = (blackouts ? Object.values(blackouts).reduce((count, blackout) => {
      return count + Number(blackout.blackoutTypeWord !== 'Offline Only')
    }, 0) : 0)
    let finalizedBookings = (bookings ? Object.values(bookings).reduce((count, booking) => {
      return count + Number(booking.finalized)
    }, 0) : 0)
    campsite.blackouts = blackouts
    campsite.bookings = bookings
    campsite.datesAvailable = 7 - (strictBlackouts + finalizedBookings)
    return campsite
  })
}
export const setCampsiteReserver = (state, payload) => {
  state.campsites[payload.campsiteIndex].bookings[payload.date].person = payload.data
  state.campsites = [...state.campsites]
}
export const setParkingAreas = (state, payload) => {
  state.parkingAreas = payload
}
export const setParkingWeek = (state, payload) => {
  // appends the week to parking areas
  state.parkingAreas = state.parkingAreas.map((parkingArea) => {
    parkingArea.blackouts = payload.blackouts?.[parkingArea.parkingAreaID] || {}
    parkingArea.bookings = payload.bookings?.[parkingArea.parkingAreaID] || {}
    parkingArea.utilization = payload.utilization?.[parkingArea.parkingAreaID] || {}
    return parkingArea
  })
}
